import { store } from "src/store/store";
import {
  getMotionCapture,
  getNoiseCapture
} from "src/modules/activity-log/duck/selectors";
import { isFreemium } from "src/modules/auth/duck/selectors";
import { getMotionSensitivity } from "src/modules/baby-station/duck/selectors";

class EventManager {
  constructor({ mediaRecorder }) {
    this.mediaRecorder = mediaRecorder;
    this.getNoiseCapture = () => getNoiseCapture(store.getState());
    this.getMotionCapture = () => getMotionCapture(store.getState());
    this.getMotionSensitivity = () => getMotionSensitivity(store.getState());
    this.isFreeVersion = () => isFreemium(store.getState());
  }

  onNoise = (referenceId) => {
    if (this.isFreeVersion()) return;
    if (this.mediaRecorder.state !== "ready") return;
    const noiseCapture = this.getNoiseCapture();
    if (noiseCapture === "audio_only") return;
    if (noiseCapture === "audio_photo") {
      this.mediaRecorder.takeSnapshot({
        eventType: "AWAKE_PHOTO",
        referenceId
      });
    }
    if (noiseCapture === "audio_video") {
      this.mediaRecorder.startRecording({
        eventType: "AWAKE_VIDEO",
        referenceId
      });
    }
  };

  onMotion = () => {
    if (this.isFreeVersion()) return;
    if (this.mediaRecorder.state !== "ready") return;
    const motionSensitivity = this.getMotionSensitivity();
    const motionCapture = this.getMotionCapture();
    if (motionSensitivity === "MD_OFF") return;
    if (motionCapture === "photo") {
      this.mediaRecorder.takeSnapshot({ eventType: "MOTION_PHOTO" });
    }
    if (motionCapture === "video") {
      this.mediaRecorder.startRecording({ eventType: "MOTION_VIDEO" });
    }
  };

  createNotificationImageUrl = async ({ activity, monitoringId }) => {
    if (this.mediaRecorder.state !== "ready") return;
    const signedUrl = await this.mediaRecorder.createNotificationImageUrl({
      activity,
      monitoringId
    });
    return signedUrl;
  };
}

export default EventManager;
